export default "__VITE_ASSET__78b92d35__"